import _ from 'lodash'
import { store } from '@atredux/store'
import { getSelectedTool } from '@src/redux/selectors/toolSelector'
import { IhmLoginTokenProvider } from '@api/utils/IhmLoginTokenProvider'
import { UnsupportedActionException } from '@amzn/ihm-associate-tools-js-lib'
import { TokenRetrieverAllowedToolsList } from '@utils/Constants/TokenRetrieverAllowedToolsList'

/**
 * Cross Frame listener that provides the access to IhmLogin token to certain tools.
 * This listener checks for the current tool loaded in the Iframe and if the tool is allowListed,
 * it returns the IhmLogin token to the tool. Currently, it returns IhmLogin access token and
 * IhmLogin Open Id Token.
 *
 * @returns if the tools is authorized, it returns the tokens, else throws an error.
 */
export async function ihmLoginTokenRetriever () {
    const currentTool = getSelectedTool(store.getState())

    if (!TokenRetrieverAllowedToolsList || !_.includes(TokenRetrieverAllowedToolsList, currentTool.toolName)) {
        return Promise.reject(new UnsupportedActionException({
            message: 'Access Denied. The tool is not allowed to make this request.',
        }))
    }

    return Promise.resolve({
        tokenType: await IhmLoginTokenProvider.getTokenType(),
        accessToken: await IhmLoginTokenProvider.getAccessToken(),
        openIdToken: await IhmLoginTokenProvider.getIdToken(),
    })
}
